import { MatPaginatorIntl } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';


export class PaginatorI18n{
    constructor(private translateService: TranslateService) {
    }
    public getPaginatorIntl(){
        const paginatorIntl = new MatPaginatorIntl();
  
        paginatorIntl.itemsPerPageLabel = this.translateService.instant('pagination.itemsPerPageLabel');
        paginatorIntl.nextPageLabel = this.translateService.instant('pagination.nextPageLabel');;
        paginatorIntl.previousPageLabel = this.translateService.instant('pagination.previousPageLabel');
        paginatorIntl.getRangeLabel = this.RangeLabel;
        
        return paginatorIntl;        
    }
    RangeLabel = (page: number, pageSize: number, length: number) => {
        let ofLabel = this.translateService.instant('pagination.of');
        if (length == 0 || pageSize == 0) { return `0 ${ofLabel} ${length}`; }
        
        length = Math.max(length, 0);
      
        const startIndex = page * pageSize;
      
        // If the start index exceeds the list length, do not try and fix the end index to the end.
        const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
      
        return `${startIndex + 1} - ${endIndex} ${ofLabel} ${length}`;
      }      
}

export function getPaginatorIntl(translateService: TranslateService) {
  let translator = new PaginatorI18n(translateService);

  return translator.getPaginatorIntl();
}